import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExemptVendorType } from 'src/app/classes/models';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-choose-exempt-vendor-type-modal',
  templateUrl: './choose-exempt-vendor-type-modal.component.html',
  styleUrls: ['./choose-exempt-vendor-type-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChooseExemptVendorTypeModalComponent implements OnInit {
  @Input() CompanyId!: number;

  ExemptVendorTypes!: ExemptVendorType[];
  selectedExemptVendorType!: ExemptVendorType;
  exemptVendorTypeId: number | null = null;

  constructor(
    private activeModal: NgbActiveModal,
    private CompanyService: CompanyService,
    private ToastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  close() {
    this.activeModal.close(false);
  }

  closeModal(result?: any) {
    this.activeModal.close(result);
  }

  submit() {
    if (!this.exemptVendorTypeId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No ExemptVendorType Selected',
        { returnError: true }
      );
    }

    this.closeModal(this.exemptVendorTypeId);
  }

  ngOnInit(): void {
    if (!this.CompanyId) {
      throw this.ToastService.addErrorToast('Error', 'No Company ID found.', {
        returnError: true
      });
    }

    this.CompanyService.getCompanyExemptVendorTypes({
      CompanyId: this.CompanyId
    }).subscribe({
      next: (exemptVendorTypes: ExemptVendorType[]) => {
        if (!exemptVendorTypes || exemptVendorTypes.length === 0) {
          this.ToastService.addErrorToast(
            'Error',
            'No Exempt Vendor Types Found.',
            { returnError: true }
          );
          this.closeModal();
        }

        this.ExemptVendorTypes = exemptVendorTypes;
        this.cdr.markForCheck();
      }
    });
  }
}
